import { Button } from '@/view/components/ui/button'
import { Radio } from 'lucide-react'

import { Dialog } from '@/view/components/ui/dialog'
import { useLiveFormContext } from '../providers/LiveFormProvider'
import { LiveForm } from './live-form/LiveForm'

export const LiveCard = () => {
  const { isLiveModalOpen, openCreateLiveModal, setIsLiveModalOpen } =
    useLiveFormContext()

  return (
    <div className="relative">
      <div className="relative min-w-full flex-1 rounded-2xl bg-[#262933] p-5">
        <h1 className="z-20 text-xl font-semibold text-white">
          Faça um treinamento ao vivo
        </h1>
        <p className="z-20 max-w-xl text-[#9E9E9E]">
          Engaje seus alunos com aulas interativas ao vivo. Compartilhe
          conhecimento, responda perguntas em tempo real
        </p>
        <Button
          onClick={openCreateLiveModal}
          variant="outline"
          className="mt-5 rounded-full bg-transparent py-6 font-semibold text-white"
        >
          <Radio className="mr-3" />
          Iniciar transmissão
        </Button>
        <div className="absolute right-20 top-1/2  -translate-y-1/2 -rotate-12 transform">
          <Radio size={164} color="#434753" className="z-0" />
        </div>
      </div>
      <Dialog open={isLiveModalOpen} onOpenChange={setIsLiveModalOpen}>
        <LiveForm />
      </Dialog>
    </div>
  )
}
